import globalStore from '$$store/main';
import app from '$$app';

function onCalendarIntegrationCreated(event) {
  if (+GT.user.id === +event.data.userId) {
    if (event.data.type === 'google') {
      globalStore.commit('integrationGoogle/addNewLink', event.data);
    } else {
      globalStore.commit('integrationOutlook/addNewLink', event.data);
    }
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    data: event.data,
  });
}

export default onCalendarIntegrationCreated;
